import React from 'react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './NotFound.module.scss';
import clsx from 'clsx';
const NotFound = ({ title, text, icon, button }) => {
  return (
    <>
      <div className={clsx(styles.wrap)}>
        {icon ? icon : <div className={clsx(styles.notFound)}>404</div>}

        <div className={clsx(styles.title)}>{title}</div>
        <div className={clsx(styles.text)}>{text}</div>
        {button}
      </div>
    </>
  );
};

export default NotFound;
